<template></template>

<script>
import Color from "color";
import { mapGetters } from "vuex";
import * as Getters from "@/store/constants/getters";

export default {
    created() {
        this.initBranding();
    },
    computed: {
        ...mapGetters([Getters.BRAND_COLOR, Getters.DEFAULT_BRAND_COLOR]),
    },
    methods: {
        initBranding() {
            let brand_color = this[Getters.BRAND_COLOR];
            let default_brand_color = this[Getters.DEFAULT_BRAND_COLOR];
            if (brand_color.toLowerCase() === default_brand_color.toLowerCase()) {
                return;
            }
            axios.get(`/css/branding.css`).then((response) => {
                let css = response.data
                    .replaceAll("$primaryButtonTextColor", "white")
                    .replaceAll("$primaryButtonBackgroundColor", brand_color)
                    .replaceAll(
                        "$primaryButtonHoverBackgroundColor",
                        Color(brand_color).lighten(0.075)
                    )
                    .replaceAll(
                        "$primaryButtonActiveBackgroundColor",
                        Color(brand_color).darken(0.1)
                    )
                    .replaceAll("$brandColor", brand_color)
                    .replaceAll(
                        "$primaryButtonDisabledBackgroundColor",
                        Color(brand_color).lighten(0.5)
                    );
                let head =
                    document.head || document.getElementsByTagName("head")[0];
                let style = $('<style type="text/css"/>')[0];
                head.appendChild(style);
                style.appendChild(document.createTextNode(css));
            });
        },
    },
};
</script>
